import { z } from 'zod';
import { StoryHistoryEntrySchema } from './storyHistory';

// ============================================
// 故事历史原文归档类型
// ============================================

export const StoryHistoryArchiveRecordKindSchema = z.enum(['session_block']);
export type StoryHistoryArchiveRecordKind = z.infer<typeof StoryHistoryArchiveRecordKindSchema>;

export const StoryHistoryArchiveRecordSchema = z.object({
  id: z.string(),
  archivedAt: z.number(),
  kind: StoryHistoryArchiveRecordKindSchema.default('session_block'),
  sourceBlockId: z.string(),
  sourceSummaryEntryId: z.string().optional(),
  sessionKey: z.string(),
  sceneName: z.string().optional(),
  participantIds: z.array(z.string()).default([]),
  startedAt: z.number(),
  endedAt: z.number(),
  startedGameTime: z.string().optional(),
  endedGameTime: z.string().optional(),
  bridgeSystemEntries: z.array(StoryHistoryEntrySchema).default([]),
  sessionEntries: z.array(StoryHistoryEntrySchema).default([]),
  metadata: z.record(z.string(), z.unknown()).optional(),
});
export type StoryHistoryArchiveRecord = z.infer<typeof StoryHistoryArchiveRecordSchema>;

export const StoryHistoryArchiveRecordInputSchema = StoryHistoryArchiveRecordSchema.omit({
  id: true,
  archivedAt: true,
}).extend({
  id: z.string().optional(),
  archivedAt: z.number().optional(),
});
export type StoryHistoryArchiveRecordInput = z.infer<typeof StoryHistoryArchiveRecordInputSchema>;

export const StoryHistoryArchiveQuerySchema = z.object({
  sourceSummaryEntryId: z.string().optional(),
  sessionKey: z.string().optional(),
  sceneName: z.string().optional(),
  participantId: z.string().optional(),
  entryId: z.string().optional(),
  keyword: z.string().optional(),
  limit: z.number().int().positive().optional(),
});
export type StoryHistoryArchiveQuery = z.infer<typeof StoryHistoryArchiveQuerySchema>;

export const StoryHistoryArchiveStateSchema = z.object({
  records: z.array(StoryHistoryArchiveRecordSchema),
  maxEntries: z.number().int().positive().default(10000),
});
export type StoryHistoryArchiveState = z.infer<typeof StoryHistoryArchiveStateSchema>;
